import { TAny } from './blog';
import { IPhoneData, ISpecialBusinessNameType } from './bussines';
import { ICountryDetail } from './countries';
import { IbillingMethod, ICommentsAndObservations, TnudosCare } from './global';
import { ObjectKey } from './pills';
import { IbankAccountInfo, TplatformSubscription } from './paymentDetails';
import { PRODUCT_CATEGORY } from './category';
import { IStockReservation } from './stockOrders';
import { IMinProducts } from './traking';
import { IProductInfo } from './products';
import { IConfiguration, TProductConfigResponse } from './product.configuration.types';

export interface IordersByType {
  En_proceso_de_pago: number;
  Por_llamar__Multi_direcciones: number;
  Proceso_de_entrega: number;
  Entregados: number;
  Cancelados: number;
}

export interface IOrderDetailsTabList {
  tabId: number;
  tabName: string;
  tabComponent: JSX.Element;
}

export interface ICountryOrganization {
  id: number;
  code: string;
  name: string;
  flag: string;
}
export interface IOrgData {
  organizationName: string;
  organizationDocument: string;
  countryOrganization: ICountryOrganization;
  organizationId?: number;
  requiresPO?: boolean | null;
}
export interface IUserData {
  firstName: string;
  profilePhoto?: string;
  email?: string;
  lastName?: string;
  phoneData?: IPhoneData;
  role?: string;
}

export interface IPaymentData {
  paymentMethod: null | string;
  subTotalUsd: null | string | number;
  totalUsd: null | string | number;
  totalMXN: null | string | number;
  commission: null | string | number;
  shipmentValue: null | number | number;
  shipmentTotalUsd?: number | null;
  shipmentTotal?: number | null;
  paymentLink: null | string;
  proofOfPayment: null | string;
  exchangeRate: null | string | number;
  total: null | string | number;
  currency: string;
  committedPaymentDate?: string;
  orderPriceId: number;
  otherExpenses: IOtherExpenses[];
  taxValue?: string;
  taxValueUsd?: string;
  wasPaymentAutomationAttempted?: boolean;
  paymentAgreementDays?: number | null;
}

export interface IProductDelivery {
  id: number;
  name: string;
  sku?: string;
  serial?: string;
  iPills?: TAny;
  brand?: string;
  brandImage?: string;
  category?: string;
  saleId?: number;
  nudosCareName?: TnudosCare | null;
  isRequestedChange?: boolean;
  skuDelivery?: string;

  //new atributes

  unit?: string;
  serials?: ISerials[];
  pills: ObjectKey<string>;
  mpn?: string | null;
  mpnId?: number | null;
  stockReservation?: IStockReservation | null;
}

export interface ITrackingInfo {
  estimatedDeliveryDate?: null | string;
  trackingLink?: null | string;
  trackerNumber?: null | string | number;
  deliveryDate?: null | string; // This is the date that the ops user selected in the date picker as the delivery date for a shipment
  currentEstimatedDeliverDate?: null | string;
  oldEstimatedDeliveryDates?: string[];
}

export interface ICountry {
  id: number;
  name: string;
  flag: string;
  code: string;
  timeZone?: number | null;
}

export interface IReceiverInfo {
  receiverName: string;
  receiverPhone: string;
  receiverIdDocument: string;
  receiverPhoneCountryCode: string;
}

export interface IshipmentStatusDates {
  pending?: string;
  confirmed?: string;
  deliveryProcess?: string;
  delivered?: string; // This is the date that the shipment was moved to the "Entregado" status (ie, the createdAt of that record in ShipmentStatusLog)
  cancelled?: string;
}

export interface IUserInfo {
  phoneData: IPhoneData;
  photoProfile?: string;
  lastName: string;
  firstName: string;
  userId: number;
}
export interface IReports {
  id: number;
  status: REPORT_STATUS.OPEN | REPORT_STATUS.CLOSED | REPORT_STATUS.RESOLVED;
}
export enum REPORT_STATUS {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  RESOLVED = 'RESOLVED'
}

export enum EDIT_FIELDS {
  PHONE_NUMBER = 'phoneNumber',
  CITY = 'city',
  ADDRESS = 'address',
  ADDITIONAL_REFERENCES = 'additionalReferences',
  ZIP_CODE = 'zipCode',
  RECEIVER_NAME = 'receiverName',
  RECEIVER_ID_DOCUMENT = 'receiverIdDocument'
}

export enum SHIPMENT_PLATFORM {
  SOGA = 'SOGA',
  NODI = 'NODI'
}

export enum LIST_PRODUCTS_TYPE {
  CLIENTS = 'clients',
  STOCK_BORD = 'stock'
}

export interface IEditShipments {
  editOnlyOrder: boolean;
  id: number;
  platform: SHIPMENT_PLATFORM;
  editedFields: string[];
}

export interface IGlobalHistory {
  editLocationId?: number;
  reportId?: number;
  platform?: SHIPMENT_PLATFORM;
  createdAt: string;
  typeLog: 'report' | 'edition';
  logId?: number;
}

export type IShipmentDataWithoutShipments = Omit<IShipmentData, 'shipments'>;
export interface ISerials {
  id: number;
  serial: string | null;
}

export interface IShipmentData {
  shipmentId: number;
  shipmentGroupId: number;
  country: ICountry;
  deliveryAddress: string;
  unit: number;
  saleValue?: number | null;
  saleValueUsd?: number | null;
  products: IProductDelivery[];
  status: string;
  statusId: number;
  trackingInfo: ITrackingInfo;
  place?: string;
  city: string;
  cityId: number;
  additionalReferences?: string;
  zipCode: string;
  receiverInfo: IReceiverInfo;
  userInfo: IUserInfo;
  shipmentStatusDates: IshipmentStatusDates;
  reports: IReports[];
  locationId: number;
  editShipments?: IEditShipments;
  globalHistory?: IGlobalHistory[];
  warehouseTemporaryStorage?: IWarehouseTemporaryStorage;

  //new atributes

  orderId?: number;
  destinationName?: string;
  destinationAddress?: string;
  receiverIdDocument?: string;
  receiverName?: string;
  receiverPhone?: string;
  stockShipmentUuid: string;
  startDay?: string;
}

export interface IDestination {
  place?: string;
  countryName?: string;
  countryCode?: string;
  receiverName?: string;
}

export interface IPrice {
  value?: number;
  valueUsd?: number;
}

export interface IShipmentGroupData {
  id: number;
  destination: IDestination | null;
  price: IPrice | null;
}

export interface IGeneralData {
  orgData: IOrgData;
  userData: IUserData;
  paymentData: IPaymentData;
  shipmentData: IShipmentData[];
  shipmentGroupsData: IShipmentGroupData[];
  bankAccountInfo?: IbankAccountInfo | null;
}

export interface IorderDetailsDates {
  createdAt: string;
  paymentDate?: string;
  activationDate?: string;
  deliveryDate?: string;
  cancelledDate?: string;
}

export interface DTOgetOrderDetailedData {
  orderId: number | string;
  purchaseOrder: string | null;
  orderCreated: string;
  statusName: string;
  numberOfShipments?: number | null;
  invoiceUrl?: string | null;
  invoiceEmissionDate?: string | null;
  listProducts: IorderProductsData;
  billingData: IbillingData;
  billingMethod?: IbillingMethod;
  generalData: IGeneralData;
  statusMethod?: string;
  paymentDate?: string;
  invoiceNumber?: string;
  orderComments?: ICommentsAndObservations[];
  orderDates: IorderDetailsDates;
  hasActiveCredit?: boolean;
  purchaseOrderUrl?: string | null;
  couponDiscountAmount?: number;
  needInvoice?: boolean | null;
  pdfUrl?: string | null;
}

export interface IorderProductsData {
  [key: string]: IreferencesByCountry;
}

export interface IreferencesByCountry {
  countryId?: number | null;
  name?: string | null;
  flag?: string | null;
  exchangeRate?: string | null;
  references: IproductReferenceDataInCountry[];
}

export interface IproductReferenceDataInCountry {
  referenceId?: string | number | null;
  productName?: string | null;
  brand?: string | null;
  brandImage?: string | null;
  sku?: string | null;
  pills?: IpillsByReference | null;
  items?: IproductItemData[] | null;
  quantity?: number | null;
  unitPrice?: number | null;
  total?: number | null;
}

export interface IpillsByReference {
  [key: string]: string;
}

export interface IData {
  name: string;
  value: string;
}

export interface IAdditionalActions {
  uuid: string;
  actionId: number;
  actionName: string;
  confirmedAt: string | null;
}

export interface IproductItemData {
  uuid?: string | null;
  saleId?: string | number | null;
  serial?: string | null;
  purchaseValue?: string | number | null;
  currency?: string | null;
  provider?: string | null;
  providerId?: number | null;
  providerPurchaseOrder?: string | null;
  alternateSku?: string | null;
  nudosCareName?: TnudosCare | null;
  category?: PRODUCT_CATEGORY | null;
  productId?: string | number | null;
  configurations?: TProductConfigResponse[];
  shipmentGroupId?: number | null;
  mpn?: string | null;
  mpnId?: number | null;
  stockReservation?: IStockReservation | null;
  destination?: IDestination | null;
}

export interface ItaxationRelatedDataRequiredForBilling {
  id?: number | null;
  code?: string;
  name?: string;
}

export interface IAdditionalBillingData {
  additionalBillingDataTypeId: number;
  value?: string;
}
export interface IbillingData {
  id?: number | null;
  countryId?: number | null;
  organizationId?: number | null;
  countryBilling?: string | null;
  countryCode?: string;
  specialBusinessNameType?: ISpecialBusinessNameType;
  specialBusinessNameTypeId?: number;
  name?: string | null;
  businessName?: string | null;
  document?: string | null;
  state?: string | null;
  city?: string | null;
  additionalReferences?: string | null;
  zipCode?: string | null;
  address?: string | null;
  email?: string;
  taxSituationDocUrl?: string | null;
  documentCountry?: ICountryDetail;
  taxSituation?: ItaxationRelatedDataRequiredForBilling;
  taxUse?: ItaxationRelatedDataRequiredForBilling;
  phone?: string;
  phoneCountry?: ICountryDetail;
  phoneCountryId?: number;
  fantasyName?: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  colony?: string;
  additionalBillingData?: IAdditionalBillingData[];
}
export interface IorganizationData {
  userFirstName: string;
  userLastName: string;
  userPhone: string;
  coutryCode: Tcountry;
  userEmail: string;
  organizationName: string;
  organizationDocument: string;
  phoneData?: IPhoneData;
  userPhoneData?: IPhoneData;
}
export interface IpaymentData {
  paymentType: string;
  subTotal: string;
  tax: string;
  total: string;
  payOff: number | boolean | null;
  approvedDays?: number | string | null;
  deadline?: string | null;
}

export interface IaddressData {
  address: string;
  additionalReferences: string;
  receiverName: string;
  receiverPhone: string;
}

export interface BillingFileData {
  orderId: number;
  invoiceUrl?: string;
  invoiceEmissionDate?: string;
}

export type Tcountry = 'co' | 'mx' | 'pe' | 'arg' | 'cl';

export interface IproviderInfo {
  id: number;
  countryId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  countryCode?: string;
}

export interface IMPNInfo {
  id: number;
  mpn: string;
  brandId: number | null;
  brand: string | null;
  description: string | null;
  class: string;
}

export interface INPMCreated {
  id: number;
  brand: string;
  mpn: string;
  brandId: number;
}

export interface IResellerInfo {
  resellerId: number;
  reseller: string;
}

export interface IReseller {
  id: number;
  uuid: string;
  resellerId: string;
  countryId: number;
  countryCode: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export interface DTOupdateOrderProductsInformation {
  saleId: number;
  serial?: string | null;
  purchaseValue?: number | null;
  providerId?: number | null;
  providerName?: string | null;
  deliveryDate?: string | null;
}

export interface DTOcreateNewProvider {
  name: string;
  countryId: number;
  countryCode: string;
}

export interface DTOcreateNewReseller {
  resellerId: string;
  countryId: number;
  countryCode: string;
}

export interface IShimpentStatus {
  shipmentId: number;
  status: 'WITH_DATE' | 'WITHOUT_DATE' | 'DELIVERED' | 'LATE' | 'DELIVERY_LATE';
}

export interface IShipmentDestinationCountry {
  id: number;
  name: string;
  flag: string;
  code: string;
  timeZone: number;
}

export type TShipmentDestinationPlace = 'user' | 'nudos' | 'office';

export interface IOrderShipmentReceiverInfo {
  receiverIdDocument?: string;
  receiverPhone?: string;
  receiverPhoneCountryCode?: string;
}

export interface IOrderShipmentProduct {
  id: number;
  name: string;
  sku?: string;
  serial?: string;
  brand?: string;
  brandImage?: string;
  category?: string;
  nudosCareName?: TnudosCare | null;
  pills?: ObjectKey<string>;
  quantity?: number;
  status?: string;
  statusId?: number;
}

export interface IOrderShipment {
  id: number;
  destinationCountryId: number;
  receiverName: string;
  destinationPlace: TShipmentDestinationPlace;
  destinationAddress: string | null;
  city: string;
  destinationCountry: IShipmentDestinationCountry;
  editShipments: unknown[];
  warehouseTemporaryStorage: unknown[];
  zipCode?: string;
  additionalReferences?: string;
  receiverInfo?: IOrderShipmentReceiverInfo;
  products?: IOrderShipmentProduct[];
  trackingInfo?: ITrackingInfo;
  statusId?: number;
}

export interface IProductList {
  id: string;
  orderId: number | string;
  organizationName?: string | null;
  organizationId?: number | null;
  countryOrganization?: ICountryDetail | null;
  paymentType?: string | null;
  total?: string | null;
  totalUsd?: string | null;
  invoiceUrl?: string | null;
  invoiceNumber?: string | null;
  uploadedInvoiceDate?: string | null;
  committedPaymentDate?: string | null;
  optionPayment?: string | null;
  invoice?: File | null;
  proofOfPayment?: File | null;
  needInvoice?: string | null;
  paymentLink?: string | null;
  billingProvider?: string | null;
  proofOfPaymentUrl?: string | null;
  statusId?: number | null;
  statusName?: string | null;
  numberOfShipments?: number | null;
  countriesShipments?: ICountryDetail[] | null;
  createdAt?: string | null;
  cancelledDate?: string | null;
  deliveryDate?: string | null;
  reasonToCancel?: string | null;
  currency?: string;
  shimpentStatus?: IShimpentStatus[];
  estimatedDeliveryDate?: string;
  commitedPaymentDate?: string;
  orderComments?: ICommentsAndObservations[];
  editShipment?: IEditShipments[];
  levelSubscription?: string;
  hasConfig?: boolean;
  orderTemporaryStorageReasons?: string[];
  hasPendingConfig?: boolean;
  responsibleIds?: number[];
  slaDeadline?: string;
  slaStatus?: SLA_STATUS;
  shipments?: IOrderShipment[];
}

export enum SLA_STATUS {
  ON_TIME = 'ON_TIME',
  WARNING_48H = 'WARNING_48H',
  WARNING_24H = 'WARNING_24H',
  OVERDUE = 'OVERDUE'
}

export enum ORDER_SHIPMENT_STATUS {
  PENDING_CONFIRMATION = 'Pendiente de confirmación',
  CONFIRMED = 'Confirmado',
  PREPARATION = 'Preparación',
  TRANSIT_TO_WAREHOUSE = 'Tránsito a bodega',
  IN_WAREHOUSE = 'En bodega',
  TRANSIT_TO_DESTINATION = 'Tránsito a destino final',
  DELIVERED = 'Entregado',
  CANCELLED = 'Cancelado'
}

export interface IorderComments {
  id: number;
  comments: string;
  mentions: number[];
}

export type TBodyUpdateOrder = {
  invoiceNumber?: string | null;
  paymentLink?: string | null;
  committedPaymentDate?: string | null;
  optionPayment?: string | null;
  proofOfPayment?: File | null;
  invoice?: File | null;
};
export interface IMinProductDetail {
  id: string;
  sku?: string;
  serial?: string;
  iPills?: TAny;
  brand?: string;
  brandImg?: string;
}

export interface IProductsInternal {
  orderId: number;
  createdAt: string;
  multipleAddress: number;
  called: string | number | null | any;
  statusName: string;
  productName: string;
  brand: string;
  referenceId: string;
  salevalue: string;
  saleId: number;
  serial: string | number | null;
  SaleBusinessInfoId: string | number | null;
  providerId: string | number | null;
  providerName: string | number | null;
  purchaseValue: string | number | null;
  deliveryDate: string | number | null;
  sku: string;
  pills: any;
  brandImage: string;
  items: IProductsInternal[];
  category: string;
}

export interface IFullOrderDetail {
  products: IProductsInternal[];
}

export interface IBodyDocument {
  orderId: string | number;
  proofOfPaymentUrl: string;
}

export interface IMinDetails {
  saleId: string | number;
  deliveryDate: string | number;
  serial: string | number;
  error?: string;
}

export interface DTOgetOrderFilters {
  amountFilters: ILimits;
  countries: string[];
}

export interface DTOgetKamFilters {
  id: string;
  email: string;
}

export interface ILimits {
  max: string;
  min: string;
}

export interface IComments {
  id?: number | null;
  text: string;
  orderId?: number;
  isDelete?: boolean;
}

export interface DTOpostPaymentLink {
  paymentLink: string;
}

export interface ISerialErrors {
  errors: string;
  saleId: number;
  serial: string;
}

interface ILisItems {
  quantity: number;
  items: IProductList[];
}

export interface IDataShopping {
  unDate?: ILisItems;
  withDate?: ILisItems;
  lateDate?: ILisItems;
}

export interface ISharedModules {
  title: string;
  key: number;
  active: boolean;
}

export const PAYMENTS_PROVIDER = 'Stripe';

export enum ORDER_COMMENT_TYPES_ENUM {
  OPS_NOTE = 'orderOperationNote'
}

export interface IcreateOrderComment {
  commentType: ORDER_COMMENT_TYPES_ENUM;
  orderId: number;
  userId: number;
  comments: string;
  mentions: number[];
  commentImage?: File;
}

export interface IupdateOrderComment {
  comments: string;
  userId: number;
}

export interface IOption {
  name: string;
  ShipmentStatusId: number;
}

export enum ORDER_STATUS {
  PENDING = 'Pendiente de confirmación',
  ACTIVE = 'Activa',
  DELIVERED = 'Entregada',
  CANCELLED = 'Cancelada'
}

export enum ORDER_STATUS_ID {
  PENDING = 1,
  ACTIVE = 2,
  DELIVERED = 3,
  CANCELLED = 4
}

export enum ORDER_PROPERTIES_TO_SEARCH {
  ORDER_NUMBER = 'Número de orden',
  ORGANIZATION_NAME = 'Nombre de empresa',
  EMPLOYEE_NAME = 'Nombre de empleado',
  SERIAL_NUMBER = 'Número de serial',
  PURCHASE_ORDER = 'Número de PO'
}

export enum SHIPMENT_STATUS {
  PENDING = 'Pendiente de confirmación',
  CONFIRMED = 'Confirmado',
  WAREHOUSE_STOP = 'En bodega',
  DELIVERY_PROCESS = 'Proceso de entrega',
  DELIVERED = 'Entregado',
  CANCELLED = 'Cancelado'
}

export enum SHIPMENT_STATUS_ID {
  PENDING = 1,
  CONFIRMED = 2,
  DELIVERY_PROCESS = 3,
  WAREHOUSE_STOP = 6,
  DELIVERED = 4,
  CANCELLED = 5
}

export enum SHIPMENT_PLACE_TEXT {
  user = 'Empleado',
  nudos = '.bord Warehouse',
  office = 'Oficina'
}

export enum REPORT_OPTIONS {
  PHONE_NUMBER = 'phoneNumber',
  CITY = 'city',
  ADDRESS = 'address',
  ADDITIONAL_REFERENCES = 'additionalReferences',
  ZIP_CODE = 'zipCode'
}

export enum PAYMENT_TYPES {
  TRANSFER_MXN = 'Transf. MXN',
  CARD_MXN = 'Tarjeta crédito',
  TRANSFER_USD = 'Transf. USD',
  INTERNATIONAL_CARD = 'Tarjeta internacional',
  TRANSFER_COP = 'Transf. COP',
  CARD_COP = 'Tarjeta crédito COP',
  TRANSFER_PEN = 'Transf. PEN',
  TRANSFER_ARS = 'Transf. ARS',
  // Credito metodos de pago en ordenes
  BORD_CREDIT_MXN = 'Crédito Bord MXN',
  BORD_CREDIT_USD = 'Crédito Bord USD',
  BORD_CREDIT_COP = 'Crédito Bord COP',
  BORD_CREDIT_PEN = 'Crédito Bord PEN',
  BORD_CREDIT_ARS = 'Crédito Bord ARS',
  BORD_CREDIT_CLP = 'Crédito Bord CLP',
  BORD_CREDIT_BRL = 'Crédito Bord BRL',
  //Son metodos de facturacion no de pago por lo tanto no deben incluirse en esta lista
  CARD_USD_LLC = 'Tarjeta internacional LLC',
  CARD_USD_CORP = 'Tarjeta internacional CORP',
  TRANSFER_CLP = 'Transf. CLP',
  TRANSFER_BRL = 'Transf. BRL'
}

export const BORD_CREDIT_PAYMENT_TYPES = [
  PAYMENT_TYPES.BORD_CREDIT_MXN,
  PAYMENT_TYPES.BORD_CREDIT_USD,
  PAYMENT_TYPES.BORD_CREDIT_COP,
  PAYMENT_TYPES.BORD_CREDIT_PEN,
  PAYMENT_TYPES.BORD_CREDIT_ARS,
  PAYMENT_TYPES.BORD_CREDIT_CLP,
  PAYMENT_TYPES.BORD_CREDIT_BRL
];

export const METHODS_ENABLE_PAYMENT_LINK_SL = [
  PAYMENT_TYPES.INTERNATIONAL_CARD,
  PAYMENT_TYPES.CARD_COP,
  PAYMENT_TYPES.CARD_MXN
];

export const listOfPaymentMethodsAndExchangeRates = [
  PAYMENT_TYPES.TRANSFER_MXN,
  PAYMENT_TYPES.CARD_MXN,
  PAYMENT_TYPES.BORD_CREDIT_MXN,
  PAYMENT_TYPES.CARD_COP,
  PAYMENT_TYPES.TRANSFER_COP,
  PAYMENT_TYPES.BORD_CREDIT_COP,
  PAYMENT_TYPES.TRANSFER_CLP,
  PAYMENT_TYPES.BORD_CREDIT_CLP
];

export enum TYPES_OF_BILLING {
  MANUAL = 'manual',
  GIGSTACK = 'gigstack',
  STRIPE_USA_NUDOS_LLC = 'stripe_usa_nudos_llc',
  STRIPE_USA_NUDOS_CORP = 'stripe_usa_nudos_c_corp'
}

export enum BILLING_METHODS_NAME {
  INTERNATIONAL_SALE = 'international_sale',
  LOCAL_SALE_COLOMBIA = 'local_sale_colombia',
  LOCAL_SALE_MEXICO = 'local_sale_mexico',
  LOCAL_SALE_PERU = 'local_sale_peru',
  LOCAL_SALE_USA = 'local_sale_usa',
  LOCAL_SALE_URUGUAY = 'local_sale_uruguay',
  LOCAL_SALE_TRADING_ENTITY_URUGUAY = 'local_sale_trading_entity_uruguay',
  LOCAL_SALE_FREE_ZONE_ENTITY_URUGUAY = 'local_sale_free_zone_entity_uruguay',
  LOCAL_SALE_ARGENTINA = 'local_sale_argentina',
  INTERNATIONAL_SALE_URUGUAY = 'international_sale_uruguay',
  INTERNATIONAL_SALE_MEXICO = 'international_sale_mexico'
}

export enum ORDER_STATUS_NAME {
  TOCONFIRMED = 'por confirmar',
  CONFIRMED = 'confirmado',
  ACTIVE = 'activo',
  DELIVERED = 'entregado',
  CANCELLED = 'cancelado',
  INPROCESS = 'en proceso',
  DELAYED = 'atrasado'
}
export interface IReportData {
  orderId: number;
  shipmentId: number;
  userId: number;
  wrongAttributes: string[];
}

export interface IOptionsReportList {
  id: number;
  label: string;
  value: REPORT_OPTIONS;
}

export interface ICoordinates {
  lat?: string | null;
  lng?: string | null;
}

export interface IreceiverInformation {
  receiverName?: string | null;
  receiverPhone?: string | null;
  receiverPhoneCountry?: ICountryDetail | null;
  receiverIdDocument?: string | null;
  receiverPhoneCountryCode?: string;
}

export interface IorganizationOfficeData {
  locationId?: number;
  zipCode?: string | null;
  additionalReferences?: string | null;
  address?: string | null;
  coordinates?: ICoordinates;
  city?: string;
  cityId?: number | null;
  countryId?: number;
  countryCode?: string;
  country?: {
    id: number;
    code: string;
    name: string;
    flag: string;
  };
}

export interface IreceiverInfo {
  name: string;
  phone: string;
}
export interface IdeliveryAddress {
  address?: string | null;
  coordinates?: ICoordinates | null;
  additionalReferences?: string | null;
  receiverInformation?: IreceiverInfo | null;
  country?: string | null;
  zipCode?: string | null;
  city?: string | null;
  cityId?: number | null;
}
export interface DTOupdateEmployeeData {
  firstName?: string;
  lastName?: string;
  personalId?: string;
  phone?: string | null;
  city?: string;
  cityId?: number | null;
  area?: string;
  countryPhoneId: number | null;
  position?: string;
  photoProfileUrl?: string;
  address?: IdeliveryAddress | null;
  countryId: number;
}
export interface IupdateShipmentInformation {
  userInfo?: DTOupdateEmployeeData;
  officeInfo?: IorganizationOfficeData;
  officeReceiverInfo?: IreceiverInformation;
  onlyOrder: boolean;
  platform: SHIPMENT_PLATFORM;
}

export interface IUpdateConfirmEdition {
  reportId: number;
  status: 'OPEN' | 'CLOSED';
  shipmentId: number;
  haveReport: boolean;
}
export interface ISendProductsToWarehouse {
  shipmentGroupId: number;
}
export interface IAdditionalTax {
  iva?: string | number;
  exchangeRate?: string;
  others?: string;
  conceptOfOthers?: string;
}

export interface IOtherExpenses {
  orderPriceId: number;
  concept: string;
  value?: number;
  valueUsd?: number;
}
export interface IUpdateTaxInfo {
  exchangeRate: number;
  subtotalTaxValueUsd: number;
  other?: IOtherExpenses[];
}

export interface IupdateOrderPurchaseOrder {
  orderId: number | string;
  purchaseOrder?: string | null;
}

export enum ORDER_STATUS_NAME_TRIM {
  DELIVERED = 'entregada',
  CANCELLED = 'cancelada'
}

export enum TEMPORARY_STORAGE_REASON_TYPE_ID {
  CONFIGURATION = 1,
  PREPARATION = 2,
  INVOICE = 3
}

export enum TEMPORARY_STORAGE_REASON_TYPE_NAME {
  CONFIGURATION = 'Configuración',
  PREPARATION = 'Preparación',
  INVOICE = 'Nota fiscal'
}

export interface IUpdateTemporaryStorage {
  shipmentId: number;
  reasons: TEMPORARY_STORAGE_REASON_TYPE_ID[];
  estimatedEntryDate: string;
  trackingCode?: string;
  trackingUrl?: string;
  newSerials: IMinProducts[];
}

export interface ISerialData {
  productId: number;
  serial: string;
}

export interface IShipmentSerials {
  shipmentId: number;
  newSerials: ISerialData[];
}

export interface IBulkTemporaryStorageRequest {
  shipmentIds: number[];
  reasons: number[];
  estimatedEntryDate: string;
  trackingCode?: string;
  trackingUrl?: string;
  serialsByShipment?: IShipmentSerials[];
}

export interface IBulkTemporaryStorageResponse extends IWarehouseTemporaryStorage {
  warehouseTemporaryStorageReasons: IWarehouseTemporaryStorageReason[];
}

export interface ITemporaryStorageReason {
  id: number;
  name: string;
  description: string;
  nameStringId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface IWarehouseTemporaryStorageReason {
  id: number;
  responsibleUserId: number;
  warehouseTemporaryStorageId: number;
  temporaryStorageReasonId: number;
  temporaryStorageReason: ITemporaryStorageReason;
  validUntil: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface IWarehouseTemporaryStorage {
  id: number;
  productId: number;
  locationId: number;
  estimatedEntryDate: string;
  trackingCode: string;
  trackingUrl: string;
  entryShipmentId: number;
  validUntil: string;
  responsibleUserId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  warehouseTemporaryStorageReasons: IWarehouseTemporaryStorageReason[];
}

export interface IOrderWithProductPrices {
  id: number;
  billingData?: IbillingData;
  orderPrice: IOrderPrice;
  sales: ISaleData[];
  paymentType: IPaymentTypeInfo;
  orderSummaryPDF?: string;
  organizationData?: IOrganizationDataForPriceEdition;
  shipments?: IShimpentsInfo[];
}

export interface IOrderPrice {
  id: number;
  orderId: number;
  currency: string;
  exchangeRate: number;
  subtotalSaleValueUsd?: number;
  subtotalSaleValue?: number;
  commissionValueUsd?: number;
  shipmentValueUsd?: number;
  taxValueUsd?: number;
  tax?: number;
  totalTaxes?: number;
  totalTaxesUsd?: number;
  totalValueUsd: number;
  totalValue: number;
}

export interface ISaleData {
  id: number;
  orderId: number;
  saleValue?: number;
  saleValueUsd: number;
  exchangeRate?: number;
  currency?: string;
  products: IProductInfo | null;
}

export interface IPaymentTypeInfo {
  id: number;
  name?: string;
  nameStringId?: string;
}

export interface IOrganizationDataForPriceEdition {
  organizationId: number;
  organizationName: string;
  organizationBusinessName?: string;
  platformSubscription?: TplatformSubscription;
  platformSubscriptionId?: number;
}

export interface IShimpentsInfo {
  id: number;
  destinationCountry: ICountry;
}

export interface IOrderPriceEdition {
  orderId: number;
  currency: string;
  previousTotalAmount?: number;
  newTotalAmount: number;
  totalLocalAmount?: number;
  reason?: string;
  changedByUserId?: number;
  changedAt: string;
  needInvoice: boolean;
  previousInvoiceUrl?: string;
  items: IOrderPriceEditionItem[];
  exchangeRate?: number | string;
  commissionUsd?: number;
}

export interface IOrderPriceEditionItem {
  saleId: number;
  currency: string;
  previousUnitAmount: number | string;
  newUnitAmount: number | string;
  totalLocalAmount?: number | null;
}

export enum PAYMENT_TYPE_OPTIONS {
  COUNTED = 'counted',
  PAYMENT_AGREEMENT = 'paymentAgreement',
  CARE = 'care'
}

export enum PAYMENT_TYPE_OPTIONS_TEXT {
  COUNTED = 'Al contado',
  PAYMENT_AGREEMENT = 'Acuerdo de pago',
  CARE = 'Cuidado'
}

export enum CREAT_NEW_ORDER_STOCK_STEPS {
  SELECT_WAREHOUSE = 0,
  SELECT_PRODUCTS = 1
}
export interface ISelectedShipmentData extends IShipmentData {
  place: string;
  hasTemporaryStorage?: boolean;
}

export interface ISelectionOrderProductsIdsState {
  selectedShipmentIds: number[];
  selectedShipmentsData: ISelectedShipmentData[];
  selectedProductIds: number[];
  isAllShipmentsSelected: boolean;
  isShipmentToWarehouse: boolean;
}

export interface ISelectionOrderProductsIdsActions {
  toggleShipmentSelection: (
    shipmentId: number,
    place?: string,
    shipmentData?: IShipmentData,
    hasTemporaryStorage?: boolean
  ) => void;
  toggleProductSelection: (
    productId: number,
    shipmentId?: number,
    place?: string,
    allProductIdsFromShipment?: number[],
    shipmentData?: IShipmentData,
    hasTemporaryStorage?: boolean
  ) => void;
  toggleAllShipmentsSelection: (allProductIds?: number[], shipmentsData?: ISelectedShipmentData[]) => void;
  toggleAllProductsInShipmentSelection: (
    shipmentId: number,
    productIds: number[],
    place?: string,
    shipmentData?: IShipmentData,
    hasTemporaryStorage?: boolean,
    listOfGroupedShipments?: IShipmentData[]
  ) => void;
  clearAllSelections: () => void;
  isShipmentSelected: (shipmentId: number) => { isShipmentSelected: boolean; isShipmentToWarehouse: boolean };
  isProductSelected: (productId: number) => boolean;
  isAllProductsInShipmentSelected: (shipmentId: number, productIds: number[]) => boolean;
  someSelectedShipmentIsInPlace: (place: string) => boolean;
  hasShipmentsWithDifferentPlaces: () => { isShipmentToWarehouse: boolean; onlyShipmentToWarehouse: boolean };
  hasShipmentsWithDifferentTemporaryStorage: () => {
    hasMixedTemporaryStorage: boolean;
    allHaveTemporaryStorage: boolean;
    noneHaveTemporaryStorage: boolean;
  };
  setIsShipmentToWarehouse: (isShipmentToWarehouse: boolean) => void;
}
